import { render, staticRenderFns } from "./ByFile.vue?vue&type=template&id=36c524b0&scoped=true&"
import script from "./ByFile.vue?vue&type=script&lang=js&"
export * from "./ByFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c524b0",
  null
  
)

/* custom blocks */
import block0 from "./ByFile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports